import React from "react"
import CloudinaryImage from "./Image/CloudinaryImage"
import { Box, Typography } from "@mui/material"
import { COLORS } from "../utils"

const PreviewHeader = ({ image, title, options, rightActions, mediaSlot }) => {
    return (
        <Box sx={sx.header}>
            {mediaSlot
                ? mediaSlot
                : image
                ? <CloudinaryImage
                    containerClassName={sx.recipeImage}
                    imageId={image && image.publicId}
                    width={240}
                    height={160}
                    resize="scale"
                    customQuality="auto"
                />
                : <img
                    src="/img/noImageAvailabled.png"
                    alt="Indisponible"
                    className={sx.recipeImage}
                />
            }
            <Box sx={sx.infosContainer}>
                {title &&
                    <Typography sx={sx.title}>
                        {title}
                    </Typography>
                }
                <Box sx={sx.subInfosContainer}>
                    {options.map((option, index) => (
                        <Box key={index} sx={{ ...sx.singleSubInfoContainer, ...(option.sx || {}) }}>
                            <Typography sx={sx.subInfoLabel}>
                                {option.label}
                            </Typography>
                            {React.isValidElement(option.value) ? option.value : (
                                <Typography sx={sx.subInfoValue}>
                                    {option.value}
                                </Typography>
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>

            {rightActions}
        </Box>
    )
}

const sx = {
    header: {
        width: "100%",
        backgroundColor: COLORS.BLUEGREY_700,
        height: 160,
        display: "flex",
        color: COLORS.WHITE
    },

    recipeImage: {
        width: 245,
        height: "100%"
    },
    infosContainer: {
        width: "calc(100% - 245px)",
        paddingLeft: "48px",
        paddingTop: "16px",
        paddingRight: "16px",
        gap: "32px"
    },
    title: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        fontWeight: 500,
        fontSize: "30px",
    },
    subInfosContainer: {
        display: "flex",
        marginTop: "16px",
        gap: "32px"
    },
    singleSubInfoContainer: {
        display: "flex",
        flexDirection: "column"
    },
    subInfoLabel: {
        fontSize: "12px"
    },
    subInfoValue: {
        fontSize: "16px",
        marginTop: "8px"
    },
    logo: {
        width: "16px",
        height: "16px"
    },
}

export default PreviewHeader
